import repository from './repsitory'

const resource = '/quotation'

export default {
    get () {
        return repository.get(`${resource}`)
    },
     getHistory () {
        return repository.get(`${resource}/history`)
    },
    getById (id) {
        return repository.get(`${resource}/${id}`)
    },
    addCard (data) {
        return repository.post(`${resource}`, data)
    },
    updateCard (data, id) {
        return repository.put(`${resource}/${id}`, data)
    },
}
